import React, { useState } from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import DescriptionIcon from '@mui/icons-material/Description';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { api } from '../../services/api';

interface ExportButtonProps {
  from: string;
  to: string;
  trailerId?: string;
}

export default function ExportButton({ from, to, trailerId }: ExportButtonProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCsvExport = () => {
    const url = api.getExportCsvUrl(from, to);
    window.open(url, '_blank');
    handleClose();
  };

  const handlePdfExport = () => {
    const url = trailerId
      ? api.getExportPdfTrailerUrl(trailerId, from, to)
      : api.getExportPdfPeriodUrl(from, to);
    window.open(url, '_blank');
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<DownloadIcon />}
        onClick={handleClick}
        size="small"
      >
        Eksporter
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleCsvExport}>
          <ListItemIcon>
            <DescriptionIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>CSV</ListItemText>
        </MenuItem>
        <MenuItem onClick={handlePdfExport}>
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>PDF Rapport</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
